import { FocusEventHandler } from 'react';
import React                 from 'react';
import { MouseEventHandler } from 'react';
import AntdButton            from 'antd/lib/button';
import { ButtonColorType }   from 'antd/lib/button/buttonHelpers';
import { ButtonType }        from 'antd/lib/button/buttonHelpers';
import { ButtonHTMLType }    from 'antd/lib/button/buttonHelpers';
import Tooltip               from '@widesk-ui/components/Tooltip';
import { TooltipProps }      from '@widesk-ui/components/Tooltip';
import { ButtonVariantType } from 'antd/es/button';

export type ButtonProps = {
	block?: boolean;
	className?: string;
	children?: React.ReactNode;
	style?: React.CSSProperties;
	type?: ButtonType;
	htmlType?: ButtonHTMLType;
	onClick?: MouseEventHandler;
	onMouseDown?: MouseEventHandler;
	disabled?: boolean;
	ghost?: boolean;
	icon?: React.ReactNode;
	id?: string;
	size?: ComponentSize;
	title?: React.ReactNode; // Texte affiché dans le tooltip du bouton
	danger?: boolean;
	loading?: boolean;
	tooltipProps?: Partial<TooltipProps>;
	onBlur?: FocusEventHandler;
	onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
	onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
	color?: ButtonColorType;
	variant?: ButtonVariantType;
	form?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const buttonEl = (
		<AntdButton
			ref={ref as any}
			style={props.style}
			type={props.type}
			block={props.block}
			className={props.className}
			htmlType={props.htmlType}
			onBlur={props.onBlur}
			onClick={props.onClick}
			onMouseDown={props.onMouseDown}
			disabled={props.loading || props.disabled}
			ghost={props.ghost}
			icon={props.icon}
			id={props.id}
			loading={props.loading}
			danger={props.danger}
			size={props.size}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			variant={props.variant}
			color={props.color}
			form={props.form}
		>
			{props.children}
		</AntdButton>
	);

	// Only wrap with Tooltip when a title is provided to avoid interfering with components
	// (e.g., Dropdown) that require a ref to a real DOM element.
	const hasTitle = props.title !== undefined && props.title !== null && props.title !== '';
	return hasTitle ? (
		<Tooltip title={props.title} {...props.tooltipProps}>{buttonEl}</Tooltip>
	) : buttonEl;
});

export default Button;
